module.exports = __webpack_public_path__ + "media/images/logo-app-store-076cdd67728c2c95c7f496df14065e4f.png";